import * as React from 'react';
import InputLabel from '@mui/material/InputLabel';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import { Box } from '@mui/material';
import { ErrorMessage, useField } from 'formik';

export default function GroupedSelect({
    formik,
    label,
    color,
    children,
    handler,
    ...props
}) {
    const [field, meta] = useField(props);
    const [selectValue, setSelectValue] = React.useState(
        field.value ? field.value : '',
    );

    const handleChange = (e) => {
        setSelectValue(e.target.value);
        const fieldName = field.name;
        formik.setFieldValue(`${fieldName}`, e.target.value);
        // -> posting fee
        handler && handler(e.target.value);
    };
    return (
        <>
            <Box
                sx={{
                    borderRadius: 1.5,
                    overflow: 'hidden',
                }}
            >
                <FormControl variant="filled" sx={{ minWidth: '100%' }}>
                    <InputLabel
                        id={label}
                        sx={{
                            color: `${color ? color : 'none'} !important`,
                        }}
                    >
                        {label}
                    </InputLabel>
                    <Select
                        native
                        className={`${meta.touched && meta.error && 'error'}`}
                        {...field}
                        {...props}
                        placeholder={label}
                        sx={{ color: `${color ? color : '#eee'}` }}
                        size={'small'}
                        displayEmpty
                        value={selectValue}
                        onChange={handleChange}
                    >
                        {children}
                    </Select>
                </FormControl>
                <ErrorMessage
                    component="span"
                    name={field.name}
                    className="error-text"
                />
            </Box>
        </>
    );
}
